import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appInputAutoFocus]'
})
export class InputAutoFocusDirective implements OnInit {

  @Input()
  public enabled: boolean = true;
  constructor(private element: ElementRef) {}

  ngOnInit() {
    if (!this.enabled) {
      return;
    }

    setTimeout(() => {
      this.element.nativeElement.focus();
    }, 0);
  }
}
